import {
  ActionTypes,
  AppState,
  APPLICATION_MANAGE_INFO,
  FUND_ALLOWCATION,
  FUND_ALLOWCATION_DETAILS,
  SCHOLARSHIP_SUMMARY_DETAILS,
} from "../types";

const initialState: AppState = {
  applicationManageData: [],
  fundAllocation: [],
  fundAllocationDetails:[],
  ScholarshipSummaryDetails:[]
};

const Reducer = (state = initialState, action: ActionTypes): AppState => {
  switch (action.type) {
    case APPLICATION_MANAGE_INFO:
      return {
        ...state,
        applicationManageData: [action.payload],
      };
    case FUND_ALLOWCATION:
      return {
        ...state,
        fundAllocation: [action.payload],
      };

    case FUND_ALLOWCATION_DETAILS:
      return {
        ...state,
        fundAllocationDetails: [action.payload],
      };
    
    case SCHOLARSHIP_SUMMARY_DETAILS:
      return {
        ...state,
        ScholarshipSummaryDetails: [action.payload],
      };

    default:
      return state;
  }
};

export default Reducer;
